const warrantyPageConfig = {
  badge: "Buyer Protection",
  title: "7-Day Return & Warranty Plans",
  subtitle:
    "Drive with confidence. Eligible certified cars come with structured support, engine coverage, and a hassle-free return window.",
  heroCta: {
    browseLabel: "Browse Certified Cars",
    browsePath: "/cars?certified=1",
    contactLabel: "Ask About Coverage",
    contactPath: "/contact?category=warranty",
  },
  plans: [
    {
      id: "assured-7",
      name: "7-Day Assured",
      badge: "Most Popular",
      returnDays: 7,
      supportDays: 30,
      engineGearbox: true,
      priceNote: "Included on certified listings",
      highlights: [
        "7-day no-questions return window",
        "30-day buyer support",
        "Engine & gearbox coverage",
      ],
    },
    {
      id: "standard",
      name: "Standard Support",
      badge: "",
      returnDays: 0,
      supportDays: 7,
      engineGearbox: false,
      priceNote: "Available on select listings",
      highlights: [
        "7-day post-purchase support",
        "Inspection report shared",
        "Dealer-assisted handover",
      ],
    },
    {
      id: "premium",
      name: "Premium Shield",
      badge: "Extended",
      returnDays: 7,
      supportDays: 90,
      engineGearbox: true,
      priceNote: "Add-on on eligible cars",
      highlights: [
        "7-day return eligibility",
        "90-day extended support",
        "Priority service assistance",
      ],
    },
  ],
  policy: {
    title: "Return & Warranty Policy",
    sections: [
      {
        id: "eligibility",
        title: "Who is eligible?",
        points: [
          "Car must be marked as certified with a published inspection report",
          "Return window starts from the date of delivery confirmation",
          "Vehicle must be within agreed kilometre limit at return request",
          "No structural damage or major modifications during the window",
        ],
      },
      {
        id: "return-process",
        title: "7-Day return process",
        steps: [
          { step: 1, title: "Request return", description: "Raise a return request from your profile within 7 days of delivery." },
          { step: 2, title: "Quick inspection", description: "Our team verifies condition against the original inspection report." },
          { step: 3, title: "Approval & pickup", description: "Once approved, we schedule pickup and initiate refund as per policy." },
          { step: 4, title: "Closure", description: "Order marked complete after settlement and documentation." },
        ],
      },
      {
        id: "warranty-coverage",
        title: "What warranty covers",
        points: [
          "Engine and gearbox issues reported within the support period",
          "Assistance with documentation and dealer coordination",
          "Transparent exclusions listed on each car page",
        ],
      },
      {
        id: "exclusions",
        title: "Common exclusions",
        points: [
          "Wear-and-tear items: tyres, brake pads, clutch",
          "Accidental or flood damage after delivery",
          "Unauthorized modifications or aftermarket parts",
          "Missed service intervals if documented at sale",
        ],
      },
    ],
  },
  order: {
    title: "Reserve with Protection",
    subtitle: "Lock this car with our buyer protection plan. No payment gateway required yet — our team will confirm your request.",
    planLabel: "Select Plan",
    notesLabel: "Additional Notes",
    notesPlaceholder: "Preferred delivery date, questions about coverage…",
    submitLabel: "Submit Protection Request",
    submittingLabel: "Submitting...",
    loginPath: "/login",
    successTitle: "Protection request submitted",
    successMessage: "Our team will contact you to confirm plan details and next steps.",
    errorTitle: "Request failed",
    errorMessage: "Could not submit your request. Please try again.",
    policyLinkLabel: "Read full policy",
    policyPath: "/warranty",
    lifecycle: [
      { status: "requested", label: "Requested", description: "Your protection request has been received." },
      { status: "confirmed", label: "Confirmed", description: "Plan confirmed by our team." },
      { status: "delivered", label: "Delivered", description: "Vehicle handover completed." },
      { status: "return_window", label: "Return Window Active", description: "7-day return window is open." },
      { status: "return_requested", label: "Return Requested", description: "Return request is under review." },
      { status: "return_approved", label: "Return Approved", description: "Return approved — pickup scheduled." },
      { status: "completed", label: "Completed", description: "Order completed successfully." },
      { status: "cancelled", label: "Cancelled", description: "This request was cancelled." },
    ],
    statusLabels: {
      requested: "Requested",
      confirmed: "Confirmed",
      delivered: "Delivered",
      return_window: "Return Window",
      return_requested: "Return Requested",
      return_approved: "Return Approved",
      completed: "Completed",
      cancelled: "Cancelled",
    },
  },
  profile: {
    badge: "Buyer Protection",
    title: "My Protection Orders",
    subtitle: "Track warranty reservations and return window status for your cars",
    emptyState: {
      title: "No protection orders yet",
      description: "Reserve a certified car with a protection plan from the car details page",
      buttonLabel: "Browse Certified Cars",
      buttonPath: "/cars",
    },
    carLabel: "Vehicle",
    planLabel: "Plan",
    statusLabel: "Status",
    requestedLabel: "Requested on",
    returnDeadlineLabel: "Return window ends",
    viewCarLabel: "View Car",
    policyLabel: "View Policy",
  },
};

export default warrantyPageConfig;
